import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 30000,
});

api.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("@MAXITRANS_TOKEN_CLIENT:");
    const tokenAdmin = localStorage.getItem("@MAXITRANS_TOKEN_ADMIN:");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    } else if (tokenAdmin) {
      config.headers["Authorization"] = `Bearer ${tokenAdmin}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
